export default {
	"scanPay.PaymentFailed": "支付失败!",
	"scanPay.PaymentCancellation": "支付取消",
	"scanPay.networkAnomaly": "网络异常",
	"scanPay.paymentSuccessful": "支付成功",
	"scanPay.PleaseUseWeChatOrAlipayToScanTheQRCodeToPay": "请使用微信或支付宝扫码付款",
	"scanPay.TheOrderIsAbnormalPleaseTryAgainLater": "订单异常，请稍后重试",
	"scanPay.PaymentAmount": "支付金额",
	"scanPay.toPay": "去支付"
}